import AuthService from "@/services/AuthService";
import MyProfileService from "@/services/MyProfileService";

export default {
  namespaced: true,
  state: {
    currentStep: 0,
    currentEmployeeForEdit: null 
    
  },
  mutations: {
    updateCurrentStep(state, payload) {
        state.currentStep = payload;    
    },

    updateCurrentEmployee(state, user) {
        state.currentEmployeeForEdit = user;
    },
   
  },
  actions: {
 
    updateCurrentStep(context, payload) {
      context.commit('updateCurrentStep', payload)
    },

    updateCurrentEmployee(context, payload) {
      context.commit('updateCurrentEmployee', payload)
    },


     },

  getters: {
    userName(state) {
      return state.currentEmployeeForEdit?.name || ''
    },

    userRole(state) {
      return state.currentEmployeeForEdit?.role || ''
    },
    

    currentStep(state) {
        return state.currentStep
      },

  }


}